import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[scKeyPress]',
  standalone: true,
})
export class KeyPressDirective {
  regex = {
    alphanumeric: /[a-zA-Z0-9]/,
    alphabetical: /[a-zA-Z]/,
    numeric: /[0-9]/,
    licensePlate: /[a-zA-Z\u0370-\u03FF0-9- ]/,
    phoneNumber: /[0-9 +]/,
  };

  @Input() scKeyPress = 'alphanumeric';

  @HostListener('keypress', ['$event'])
  onKeyPress(event) {
    let code;

    if (event.key !== undefined) {
      code = event.key;
    } else if (event.keyIdentifier !== undefined) {
      code = event.keyIdentifier;
    } else if (event.keyCode !== undefined) {
      code = String.fromCharCode(event.keyCode);
    }

    if (this.regex[this.scKeyPress].test(code)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
}
